import React, { ForwardedRef, forwardRef, ReactNode } from 'react'

import { Slate } from 'slate-react'
import { EditableProps } from 'slate-react/dist/components/editable'

import { bemJoin } from '@app/lib/bem'
import { TemplatedFormEditorReference } from '@app/lib/context/TemplatedForm'
import { EditableArea } from '@app/lib/inputs/RichEditor/editor/EditableArea'
import { StructuredText } from '@app/lib/inputs/RichEditor/types'
import { defaultEditorValue, useSlateEditor } from '@app/lib/inputs/RichEditor/useSlateEditor'
import { InputBox } from '@app/lib/layout/InputBox/InputBox'
import { MergeProps } from '@app/lib/types'

import './RichEditor.scss'

const b = bemJoin('editor')

export type RichEditorInputProps = {
  value?: StructuredText
  onChange: (value: StructuredText) => void
  name?: string
}

export type RichEditorProps = MergeProps<
  EditableProps,
  {
    before?: ReactNode
    toolbar: ReactNode
    after?: ReactNode
  } & RichEditorInputProps
>

export const RichEditor = forwardRef(
  (
    { value, onChange, before, toolbar, after, name, ...rest }: RichEditorProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const { editor } = useSlateEditor()

    const defaultValue = Array.isArray(value) && value.length > 0 ? value : defaultEditorValue

    return (
      <InputBox
        variant='outlined'
        color='neutral'
        control={
          <Slate value={defaultValue} editor={editor} onChange={onChange}>
            {before}
            <div className={b()}>
              {toolbar}
              {name ? <TemplatedFormEditorReference name={name} /> : null}
              <EditableArea ref={ref} {...rest} />
            </div>
            {after}
          </Slate>
        }
      />
    )
  }
)
